exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setAllMarkRead.cancelOrderForm .ivu-form-item{margin-bottom:20px}.setAllMarkRead.cancelOrderForm .ivu-form-item-error-tip{font-size:12px}", ""]);

// exports
